import { notification } from 'antd';
import { ACCESS_TOKEN, REFRESH_TOKEN, API_TOKEN, PRIVILEGES_TOKEN, USER_UUID,
         PASSWORD_UPDATED_AT, USER_TIMEZONE,
         PASSWORD_WARNING_SHOWN, PASSWORD_EXPIRED_MODAL_SHOWN } from "../utils/constants";
import service from "../services/Service";

export function signInApi(data) {
  return service.post('users/sign-in', data)
    .then((response) => {
      return response.data;
    })
    .then((result) => {
      if (result.login) {
        return {
          ok: result.login,
          message: result.message,
          accessToken: result.accessToken,
          refreshToken: result.refreshToken,
          apiToken: result.apiToken,
          privilegesToken: result.privilegesToken,
          userUuid: result.userUuid,
          passwordUpdatedAt: result.passwordUpdatedAt
        };
      }
      return {
        ok: result.login,
        message: result.message,
        twoFactorRequired: result.twoFactorRequired,
        twoFactorLocked: result.twoFactorLocked,
        pendingToken: result.pendingToken,
      };
    })
    .catch((err) => {
      console.log("Errorr: ", err);
      if (err.response) {
        // Request made and server responded
        // Ya existe el usuario
        return { ok: false, message: err.response.data.message };
      } else if (err.request) {
        // The request was made but no response was received
        return { ok: false, message: "No hay respuesta del servidor" };
      } else {
        // Something happened in setting up the request that triggered an Error
        return { ok: false, message: "Error" };
      }
    });
}

/**
 * Verifica el código 2FA del usuario durante el login
 * @param {Object} data - Datos para verificar 2FA
 * @param {string} data.pendingToken - Token pendiente de 2FA
 * @param {string} data.token - Código TOTP o código de recuperación
 * @returns {Promise<Object>} Resultado del login con tokens o error de 2FA
 */
export function verifyTwoFactorApi(data) {

  return service.post('users/2fa/login', data)
    .then((response) => response.data)
    .then((result) => {
      if (result.login) {
        return {
          ok: true,
          message: result.message,
          accessToken: result.accessToken,
          refreshToken: result.refreshToken,
          apiToken: result.apiToken,
          privilegesToken: result.privilegesToken,
          userUuid: result.userUuid,
          passwordUpdatedAt: result.passwordUpdatedAt,
        };
      }
      return {
        ok: false,
        message: result.message,
        twoFactorLocked: result.twoFactorLocked,
        twoFactorExpired: result.twoFactorExpired,
      };
    })
    .catch((err) => {
      if (err.response) {
        return { ok: false, message: err.response.data.message };
      } else if (err.request) {
        return { ok: false, message: "No hay respuesta del servidor" };
      } else {
        return { ok: false, message: "Error" };
      }
    });
}

export async function logout() {
  const data = { token: localStorage.getItem(API_TOKEN) };
  return await service.post('users/log-out', data)
    .then((res) => {
      if (res.data) {
        localStorage.removeItem(ACCESS_TOKEN);
        localStorage.removeItem(REFRESH_TOKEN);
        localStorage.removeItem(API_TOKEN);
        localStorage.removeItem(PRIVILEGES_TOKEN);
        localStorage.removeItem(USER_UUID);
        localStorage.removeItem('disableInterval');
        localStorage.removeItem('kiboxColumns_visible');
        localStorage.removeItem('kiwiColumns_visible');
        localStorage.removeItem(PASSWORD_UPDATED_AT);
        localStorage.removeItem(USER_TIMEZONE);
        sessionStorage.removeItem(PASSWORD_WARNING_SHOWN);
        sessionStorage.removeItem(PASSWORD_EXPIRED_MODAL_SHOWN);
        return true;
      } else {
        notification["error"]({
          message: "Error al cerrar sesión",
        });
        return false;
      }
    })
}

export async function impersonate(uuid) {
  return await service.post("users/" + uuid + "/impersonate")
    .then((res) => {
      if (res.data.ok === false) {
        return { ok: false, message: res.data.message };
      } else {
        localStorage.setItem(ACCESS_TOKEN, res.data.accessToken);
        localStorage.setItem(PRIVILEGES_TOKEN, res.data.privilegesToken);
        localStorage.setItem(API_TOKEN, res.data.apiToken);
        localStorage.setItem(USER_UUID, res.data.userUuid);
        localStorage.setItem(USER_TIMEZONE, res.data.timezone ?? '');
        localStorage.removeItem('disableInterval');
        window.location.href = "/";
        return { ok: true };
      }
    })
    .catch((err) => {
      console.log("Error devuelto: " + err);
    });
}

export function setSession(result) {
  localStorage.setItem(ACCESS_TOKEN, result.accessToken);
  localStorage.setItem(REFRESH_TOKEN, result.refreshToken);
  localStorage.setItem(API_TOKEN, result.apiToken);
  localStorage.setItem(PRIVILEGES_TOKEN, result.privilegesToken);
  localStorage.setItem(USER_UUID, result.userUuid);
  localStorage.setItem(PASSWORD_UPDATED_AT, result.passwordUpdatedAt ?? '');
  localStorage.setItem(USER_TIMEZONE, result.timezone ?? '');
}
